import { css } from '@emotion/core';
import { Banner } from '@nexus/lib-react/dist/core/Banner/Banner';
import { Paragraph4 } from '@nexus/lib-react/dist/core/Typography/Paragraph';
import mq from '../../../../../commons/styles/mediaQueries';
import styled from '../../../../../theme/styled';

export const failureCopies = [
  'dlv_returns_status_buyer_buyer_response_expired',
  'dlv_returns_status_seller_buyer_response_expired',
  'dlv_returns_status_buyer_seller_payment_expired',
  'dlv_returns_status_seller_seller_payment_expired',
  'dlv_returns_status_buyer_delivery_failed_with_provider_fault',
  'dlv_returns_status_seller_delivery_failed_with_provider_fault',
  'dlv_returns_status_buyer_delivery_failed_with_recipient_fault',
  'dlv_returns_status_seller_delivery_failed_with_recipient_fault',
  'dlv_returns_status_seller_payment_error',
  'dlv_returns_status_buyer_delivery_failed_with_sender_fault',
  'dlv_returns_status_seller_delivery_failed_with_sender_fault',
  'dlv_returns_status_buyer_payout_requested',
  'dlv_returns_status_seller_refund_requested',
  'dlv_returns_status_seller_refund_requested_negotiations_given_up',
];

export const neutralCopies = [
  'dlv_returns_status_buyer_awaiting_responses',
  'dlv_returns_status_seller_awaiting_responses',
  'dlv_returns_status_seller_buyer_responded',
  'dlv_returns_status_seller_seller_responded',
  'dlv_returns_status_buyer_delivery_label_received_point_to_point',
  'dlv_returns_status_seller_delivery_ready_to_pickup',
  'dlv_returns_status_seller_claim_raised',
  'dlv_returns_status_buyer_claim_raised',
  'dlv_returns_status_buyer_refund_requested',
  'dlv_returns_status_seller_payout_requested',
  'dlv_returns_status_seller_return_requested',
  'dlv_returns_status_buyer_return_requested',
  'dlv_returns_status_buyer_refund_requested_negotiations_given_up',
];

const Status = styled(Banner)<{ copy?: string }>`
  margin: ${({ theme }) => theme.space[16]};

  div {
    justify-content: center;
    width: 100%;
  }

  ${mq.desktop} {
    margin: ${({ theme }) => theme.space[24]} 0;
  }

  /*
    NOSONAR: blueBgLight is the default color
    and it is also being used for statuses here
  */
  ${({ copy, theme }) =>
    neutralCopies.includes(copy) &&
    css`
      background-color: ${theme.colors.yellowTintLight};
    `}

  ${({ copy, theme }) =>
    failureCopies.includes(copy) &&
    css`
      background-color: ${theme.colors.bgError};
    `}
`;

const StatusText = styled(Paragraph4)`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  text-align: center;
`;

export default {
  Status,
  StatusText,
};
